import { Input, Select } from 'antd';
import { useState } from 'react';
import { useTranslation } from '@govard/i18n-core/react';
import { getEnumLabel, SYSTEM_SOURCES } from '../../../shared/format/enum-labels.js';

export function DealSourceSelect({
  value,
  onChange,
  id,
}: {
  value?: string;
  onChange?: (value: string | undefined) => void;
  id?: string;
}) {
  const { t } = useTranslation();
  const [other, setOther] = useState(false);
  const custom = other || Boolean(value && !SYSTEM_SOURCES.some((key) => key === value));
  return (
    <div className="deal-source-select">
      <Select
        {...(id ? { id } : {})}
        aria-label={t('crm.deal_card.form.source')}
        allowClear
        showSearch
        optionFilterProp="label"
        value={custom ? '__other__' : value || undefined}
        onChange={(next: string | undefined) => {
          setOther(next === '__other__');
          onChange?.(next === '__other__' ? '' : next);
        }}
        options={[
          ...SYSTEM_SOURCES.map((key) => ({
            value: key,
            label: getEnumLabel('dealSource', key, t),
          })),
          { value: '__other__', label: t('crm.deal_detail.other_source') },
        ]}
      />
      {custom ? (
        <Input
          aria-label={t('crm.deal_detail.other_source')}
          maxLength={100}
          value={value ?? ''}
          onChange={(event) => onChange?.(event.target.value)}
        />
      ) : null}
    </div>
  );
}
